import React, { useState, useEffect } from "react";
import { IoArrowBackOutline } from "react-icons/io5";
import { TbLogout2 } from "react-icons/tb";
import { useNavigate } from "react-router";
import icon from "../assets/Icon.png";
import { url, url2 } from "../env";
import { getDelawareDate } from "../env";
import Loader from "../components/loader";
import Course from "../components/course";
import PopUp from "../components/popUp";
import Profile from "../components/profile";
import Footer from "../components/footer";



export default function AllCourses() {
    const navigate = useNavigate();
    const data = JSON.parse(localStorage.getItem("attendance_teacher"));

    const allStates = [
        {
            id: 1,
            name: "Courses"
        },
        {
            id: 2,
            name: "Profile"
        }
    ]
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [students, setStudents] = useState([]);
    const [selectedState, setSelectedState] = useState(1)

    const [popupActive, setPopUpActive] = useState({
        active: false,
        type: "",
        title: "Alert",
        description: "alert"
    })

    const checkAttendance = async (courseId, attendanceDate) => {
        setLoading(true);
        try {
            const response = await fetch(
                `${url}course-attendance/check-attendance?courseId=${courseId}&attendanceDate=${attendanceDate}`
            );
            const result = await response.json();
            setLoading(false);

            if (response.ok && result.attendanceTaken !== undefined) {
                if (result.attendanceTaken === false) {
                    setStudents(result.students);
                } else {
                    setStudents([]);
                }
                return result.attendanceTaken;
            } else {
                console.error("Unexpected API response:", result);
                return false;
            }
        } catch (error) {
            console.error("Error fetching attendance data:", error);
            setLoading(false);
            return false;
        }
    };

    const fetchAllCourses = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${url}courses/get`);
            const result = await response.json();
            setCourses(result.courses);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllCourses();
    }, []);

    const moveToAttendance = async (courseId, courseName) => {
        const isAttendanceTaken = await checkAttendance(courseId, getDelawareDate());

        if (isAttendanceTaken === false) {
            setStudents((prevStudents) => {
                const studentsToPass = prevStudents.length > 0 ? prevStudents : [];
                navigate("/attendance", {
                    state: {
                        attendanceDate: getDelawareDate(),
                        courseId: courseId,
                        students: studentsToPass,
                        courseName: courseName
                    },
                });
                return studentsToPass;
            });
        } else {
            setPopUpActive({
                active: true,
                type: "warning",
                title: "Alert",
                description: `Attendance already has been taken for ${getDelawareDate()}.`
            })
        }
    };

    const handleBackButtonClick = (e) => {
        e.preventDefault();
        localStorage.removeItem("attendance_teacher");
        sessionStorage.removeItem("attendance_teacher");
        navigate(-1);
    };

    useEffect(() => {
        if (popupActive.active) {
            const timer = setTimeout(() => {
                setPopUpActive((prevState) => ({
                    ...prevState,
                    active: false,
                    type: "",
                    title: "",
                    description: ""
                }));
            }, 4000);

            return () => clearTimeout(timer);
        }
    }, [popupActive.active]);

    return (
        <div className="all_courses">
            <div className="mainAllCoursesHeader">
                <div className="title">
                    <span className="date">السلام عليكم</span>
                    <span className="courseName">Yamin</span>
                </div>
                <div className="profile_icon_2" onClick={handleBackButtonClick} >
                    <TbLogout2 />
                </div>

                <div className="profile_icon">
                    <img src={icon} alt="Profile Icon" />
                </div>
            </div>

            <div className="toggleButtons">
                {
                    allStates.map((item, index) => {
                        return (
                            <div
                                key={index}
                                onClick={() => setSelectedState(item.id)}
                                className={selectedState === item.id ? "toggleButton_btn active" : "toggleButton_btn"}
                            >
                                {item.name}
                            </div>
                        );
                    })
                }
            </div>


            {selectedState === 1 ? (
    loading ? (
        <p>Loading courses...</p>
    ) : courses.length > 0 ? (
        <div className="coursesList">
            {courses.map((item, index) => (
                <Course
                    onclick={() => {navigate(`/course/${item.courseId}`, {
                        state: {
                            courseId: item.courseId,
                            courseName: item.courseName
                        },
                    })}}
                    key={index}
                    name={item.courseName || "Unnamed Course"}
                    img={item.courseImages?.[0]?.image_url ? `${url2}${item.courseImages[0].image_url}` : null}
                />
            ))}
        </div>
    ) : (
        <p>No courses available</p>
    )
) : (
    <Profile />
)}

            {loading && <Loader />}
            {popupActive.active && <PopUp type={popupActive.type} title={popupActive.title} description={popupActive.description} />}
            {/* <Footer/> */}
        </div>
    );
}
